/**
 * @description 常规弹窗，预约成功弹窗、重复预约弹窗默认值
 */
export const POPUP_FROM_NORMAL = 'popup-from-normal'

/**
 * @description 滚动到指定页面打开预约弹窗, 预约弹窗开启时添加到: 预约成功弹窗、重复预约弹窗
 */
export const POPUP_FROM_SCROLL = 'popup-from-scroll'

/**
 * @description 输入错误
 */
export const POPUP_FROM_PHONE_ERROR = 'popup-from-phone-error'

/**
 * @description 20 秒无预约打开预约弹窗，预约弹窗开启时添加到: 预约成功弹窗、重复预约弹窗
 */
export const POPUP_FROM_THIRTY_SECONDS = 'popup-from-twenty-seconds'

/**
 * @description 进入页面强制打开弹窗，预约弹窗开启时添加到: 预约成功弹窗、重复预约弹窗
 */
export const POPUP_FROM_MANDATORY = 'popup-from-mandatory'

export const POPUP_FROM_BOTTOM = 'popup-from-bottom'

/**
 * @description 预约成功、重复预约弹窗 class 集合
 */
export const POPUP_FROM_SET = [
    POPUP_FROM_NORMAL,
    POPUP_FROM_SCROLL,
    POPUP_FROM_THIRTY_SECONDS,
    POPUP_FROM_MANDATORY,
    POPUP_FROM_PHONE_ERROR,
    POPUP_FROM_BOTTOM,
]
